import { render, staticRenderFns } from "./HolidayCalendarSettings.vue?vue&type=template&id=23f60bc1&scoped=true&"
import script from "./HolidayCalendarSettings.vue?vue&type=script&lang=js&"
export * from "./HolidayCalendarSettings.vue?vue&type=script&lang=js&"
import style0 from "./HolidayCalendarSettings.vue?vue&type=style&index=0&id=23f60bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f60bc1",
  null
  
)

export default component.exports